// extracted by mini-css-extract-plugin
export var answer = "FAQ-module--answer--a2b48";
export var answerList = "FAQ-module--answerList--30970";
export var btn = "FAQ-module--btn--62048";
export var btnOutlinePrimary = "FAQ-module--btn-outline-primary--60373";
export var btnPrimary = "FAQ-module--btn-primary--4a25d";
export var chevron = "FAQ-module--chevron--ccdda";
export var formSelect = "FAQ-module--form-select--2a3b0";
export var inner = "FAQ-module--inner--bb3b2";
export var item = "FAQ-module--item--2f653";
export var itemOpen = "FAQ-module--itemOpen--ccee3";
export var list = "FAQ-module--list--64708";
export var question = "FAQ-module--question--600cd";
export var section = "FAQ-module--section--00d27";
export var title = "FAQ-module--title--4863e";